// extracted by mini-css-extract-plugin
module.exports = {"form":"roleForm_form_3DPKZ9i","input":"roleForm_input_O_ppuQp"};